import Axios from "axios";

import Auth from "../Auth";

Axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

Axios.interceptors.request.use(config => {
  config.headers = { Authorization: `Bearer ${Auth.getToken()}` };

  return config;
});

Axios.interceptors.response.use(null, error => {
  const status = error.response.status;

  switch (status) {
    case 401:
      break;
    case 403:
      alert("you do not have access to this feature");
      break;
    default:
      break;
  }

  return Promise.reject(error);
});

export default Axios;



// WEBPACK FOOTER //
// ./src/api/config.js